import React, { Component } from 'react';
import axios from 'axios';
import ReactCrop, { makeAspectCrop } from 'react-image-crop';
import { LightboxComponent } from '../LightboxComponent/LightboxComponent';
import Loader from '@appComponents/Loader/Loader';
import IImageUploader, { ICrop, TImageUploader } from './IImageUploader';
import noPhotoUrl from '@images/no_photo_male_big.png';

import * as style from './ImageUploaderStyles.module.scss'

export default class ImageUploader extends Component<IImageUploader, TImageUploader> {

  state: TImageUploader = {
    imageId: null,
    imageUrl: this.props.avatar ? this.props.avatar : noPhotoUrl,
    selectedFile: '',
    uploading: false,
    proceedCrop: false,
    selectedImageUrl: this.props.avatar ? this.props.avatar : noPhotoUrl,
    crop: {
      x: 0,
      y: 0,
      width: 100,
      height: 100,
    },
    displayPreview: false,
  };

  private inputElement: HTMLInputElement;

  componentDidUpdate(prevProps: IImageUploader, prevState: TImageUploader) {
    if (this.props.avatar && prevProps.avatar !== this.props.avatar && this.state.imageUrl !== this.props.avatar) {
      this.setState({ imageUrl: this.props.avatar });
    }
  }

  uploadButton() {

    const imageUploadeBtnStyle: any = this.props.type === 'cover' ? {
      position: 'absolute', top: 0, width: '100%', height: '100%', left: 0,
    } : { width: 'auto', height: 'auto', maxWidth: '167px', padding: '0' };

    return (
      <React.Fragment>
      <div
        style={imageUploadeBtnStyle}
        className={style.uploadButton}
        onClick={() => this.inputElement.click()}
      >
        {(this.props.type === 'cover') ? null : <img src={this.state.imageUrl} />}
      </div>
      <div className="hide">
        <input
          type="file"
          ref={(input) => { this.inputElement = input as HTMLInputElement; }}
          onChange={this.fileSelectedHandler}
        />
      </div>
      </React.Fragment>
    );
  }

  fileSelectedHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const reader: FileReader = new FileReader();
    const file = (event.target as any).files[0];
    const { uploadSizeLimit } = this.props;
    if (uploadSizeLimit && file && file.size > uploadSizeLimit * 1024 * 1024) {
      alert(`The file size can't exceed ${uploadSizeLimit}MB. Please upload smaller image.`);
    } else if (file) {
      this.setState({ uploading: true });

      reader.onloadend = () => {
        const imageTypes = ['image/jpeg', 'image/png'];
        if (imageTypes.includes(file.type)) {
          this.setState({
            selectedFile: file,
            uploading: false,
            proceedCrop: true,
            selectedImageUrl: String(reader.result),
            displayPreview: true,
          });
        } else {
          this.setState({
            uploading: false,
            proceedCrop: false,
          });
        }
        this.inputElement.value = '';
      };

      if (file) reader.readAsDataURL(file);
    }
  }

  onCropChange = (cropped: ICrop) => {
    if (cropped.width && cropped.height) {
      this.setState({ crop: cropped });
    }
  }

  closePreview = () => {
    this.setState({ displayPreview: false });
  }

  onImageLoaded = (image: HTMLImageElement) => {
    let { type } = this.props;
    if (type === undefined) type = 'photo';

    const aspect = ['panorama', 'cover'].includes(type) ? 16 / 3 : 1;
    this.setState({
      crop: makeAspectCrop({
        aspect,
        x: 0,
        y: 0,
        width: 50,
        height: 50,
      }, image.width / image.height),
    });
  }

  fileUploadHandler = () => {
    this.setState({
      uploading: true,
      // preview: false,
      proceedCrop: false,
    });
    this.cropping();
  }

  croppedImgBase64(image: HTMLImageElement, crop: ICrop, fileName: string) {
    const ratioW = image.naturalWidth / image.width;
    const ratioH = image.naturalHeight / image.height;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (ctx === null) return;

    canvas.width = crop.width * ratioW;
    canvas.height = crop.height * ratioH;

    ctx.drawImage(
      image,
      crop.x * ratioW,
      crop.y * ratioH,
      crop.width * ratioW,
      crop.height * ratioH,
      0,
      0,
      crop.width * ratioW,
      crop.height * ratioH
    );
    return canvas.toDataURL();
  }

  cropping() {
    const reader = new FileReader();
    const draw = (image: HTMLImageElement) => {
      const newImgUrl = this.constructor.prototype.croppedImgBase64(
        image, this.state.crop, this.state.selectedFile.name
      );

      const data = {
        image: {
          file: newImgUrl,
          type: this.props.type,
        },
      };

      this.setState({
        imageUrl: newImgUrl,
        uploading: true,
      }, () => {
        // TODO: Improve usage of BttfAxios here
        axios.post('/api/images', data)
          .then((resp) => {
            this.setState({
              imageId: resp.data.id,
              uploading: false,
            });
            this.props.getImageId({ id: resp.data.id, url: newImgUrl });
          })
          .catch((err) => {
            console.log('POST /api/images',{ err });
          });

      });
    };

    reader.addEventListener('load', () => {
      const image = new Image();
      image.width = 100;
      image.height = 100;
      image.src = String(reader.result);
      draw(image);
    }, false);

    reader.readAsDataURL(this.state.selectedFile);
  }

  reactCrop() {
    if (this.state.proceedCrop) {
      return (
        <LightboxComponent closePreview={this.closePreview} isVisible={this.state.displayPreview}>
          <div className={style.cropContainer}>
            <ReactCrop
              style={{ backgroundColor: 'transparent' }}
              src={this.state.selectedImageUrl}
              crop={this.state.crop}
              onChange={(crop: ICrop) => this.onCropChange(crop)}
              onImageLoaded={(image: HTMLImageElement) => this.onImageLoaded(image)}
            />
            <button
              type="button"
              className={[style.coverBtn, 'test-upload-file'].join(' ')}
              onClick={() => this.fileUploadHandler()}
            >
              Upload
            </button>
          </div>
        </LightboxComponent>
      );
    }
    return;
  }

  render() {
    const uploader = (
      <React.Fragment>
        {this.uploadButton()}
        {this.reactCrop()}
      </React.Fragment>
    );
    const html = (this.state.uploading) ? <Loader fullWidth={this.props.loaderFullWidth} /> : uploader;
    return (
      <React.Fragment>
        {html}
      </React.Fragment>
    );
  }
}
